import React, { useContext, useEffect } from 'react';
import { AppContext } from '../Context/AppContextProvide';
import { useHistory, withRouter } from 'react-router-dom';

const Auth = (props) => {
  const params = new URLSearchParams(window.location.search);
  const accessToken = params.get('accessToken');
  const refreshToken = params.get('refreshToken');
  // api-hub passes the provider back (google omits it for backward compatibility).
  const provider = params.get('authType') || 'google';
  const history = useHistory();
  // Hard session cap for OAuth (30 days, matching admin-portal). The short-lived access
  // token is renewed silently via /api/auth/<provider>/refresh in AppContextProvide.
  const expTime = new Date().getTime() + 30 * 24 * 60 * 60 * 1000;

  localStorage.setItem('accessToken', accessToken);
  localStorage.setItem('refreshToken', refreshToken);
  localStorage.setItem('authType', provider);
  localStorage.setItem('tokenExpiration', expTime);

  const { setAccessToken, setAuthType } = useContext(AppContext);

  useEffect(() => {
    setAccessToken(accessToken);
    setAuthType(provider);
    const returnUrl = localStorage.getItem('returnUrl');

    setTimeout(() => {
      history.push(returnUrl || '/home');
      localStorage.removeItem('returnUrl');
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, setAccessToken]);

  return <div></div>;
};

export default withRouter(Auth);
